import { render, staticRenderFns } from "./ManageRole.modal.vue?vue&type=template&id=4a3a283d"
import script from "./ManageRole.modal.vue?vue&type=script&lang=ts"
export * from "./ManageRole.modal.vue?vue&type=script&lang=ts"
import style0 from "./ManageRole.modal.vue?vue&type=style&index=0&id=4a3a283d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports